module.exports = __webpack_public_path__ + "static/benevity-a958a916c453925200482058426d923e.png";